import { render, staticRenderFns } from "./Programa-view.vue?vue&type=template&id=73bb6c60&scoped=true"
import script from "./Programa-view.vue?vue&type=script&lang=js"
export * from "./Programa-view.vue?vue&type=script&lang=js"
import style0 from "./Programa-view.vue?vue&type=style&index=0&id=73bb6c60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bb6c60",
  null
  
)

export default component.exports